<template>
  <div class="bg-white d-flex justify-content-between w-100" :class="containerClass" style="border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); padding: 5px 20px;">
    <div class="d-flex text-start draggable-handle">
      <div class="icon-wrapper me-3" :style="{backgroundColor: color+20}">
        <i :class="icon" :style="{color: color}"></i>
      </div>
      <div class="mt-2">{{ label }}</div>
    </div>
    <div class="text-end mt-2">
      <i v-if="$can(abilities.UPDATE_TYPE_ACTIVITY)" class="fas fa-edit me-5" @click="updateItem($event, id)" :style="{color: Theme.gray}"></i>
      <i v-if="$can(abilities.DELETE_TYPE_ACTIVITY)" class="fas fa-trash" @click="deleteItem($event, id)" :style="{color: Theme.gray}"></i>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { Theme } from '@/composables/theming';
import abilities from "@/composables/abilities";

const emits = defineEmits(['actionUpdate', 'actionDelete'])

const props = defineProps({
  id: String,
  icon: String,
  containerClass: String,
  label: String,
  color: String
})

function updateItem(event, id){
  event.preventDefault()
  emits('actionUpdate', id)
}

function deleteItem(event, id){
  event.preventDefault()
  emits('actionDelete', id)
}

</script>

<style scoped>
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  opacity: 0.9;
  padding: 5px;
}
i {
  font-size: 15px;
}
</style>
